import {eventUrl} from './base';
import {myAxios} from "../util/myAxios";
import type {Win} from "../entities/Win";

export function getOwnWins(): Promise<Win[]> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/wins/own`)))
    .then(response => response.data)
}

export function getWin(winId: string): Promise<Win> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/wins/${winId}`)))
    .then(response => response.data)
}

export function claimWin(winId: string): Promise<Win> {
  return myAxios()
    .then(axios => axios.put(eventUrl(`/wins/${winId}/claim`)))
    .then(response => response.data)
}

